<template>

	<div class="container">
		
		<div class="profile">
			<img src="src/img/portrait-new.jpg" alt="Profile Picture" class="profile-pic">
		</div>
		
		<div class="social-icons">

			<!-- Spotify -->
			<a title="Spotify" :href="UNDEFIANT.spotify" :className="'icon-button spotify'">

				<Icon :icon="'spotify'"></Icon>

			</a>

			<!-- Apple Music -->
			<a title="Apple Music" :href="UNDEFIANT.appleMusic" :className="'icon-button apple-music'">

				<Icon :icon="'apple-music'"></Icon>

			</a>

			<!-- iTunes -->
			<a title="iTunes" :href="UNDEFIANT.itunes" :className="'icon-button itunes'">

				<Icon :icon="'itunes'"></Icon>

			</a>

			<!-- Instagram -->
			<a title="Instagram" :href="UNDEFIANT.instagram" :className="'icon-button instagram'">

				<Icon :icon="'instagram'"></Icon>

			</a>

			<!-- YouTube -->
			<a title="YouTube" :href="UNDEFIANT.youtube" :className="'icon-button youtube'">

				<Icon :icon="'youtube'"></Icon>

			</a>
			
			<!-- YouTube Music -->
			<a title="YouTube Music" :href="UNDEFIANT.youtubeMusic" :className="'icon-button youtube-music'">

				<Icon :icon="'youtube-music'"></Icon>

			</a>

			<!-- SoundCloud -->
			<a title="SoundCloud" :href="UNDEFIANT.soundCloud" :className="'icon-button soundcloud'">

				<Icon :icon="'soundcloud'"></Icon>

			</a>

			<!-- Amazon Music -->
			<a title="Amazon Music" :href="UNDEFIANT.amazonMusic" :className="'icon-button amazon-music'">

				<Icon :icon="'amazon-music'"></Icon>

			</a>

			<!-- Deezer -->
			<a title="Deezer" :href="UNDEFIANT.deezer" :className="'icon-button deezer'">

				<Icon :icon="'deezer'"></Icon>

			</a>

			<!-- Hardtunes -->
			<a title="Hardtunes" :href="UNDEFIANT.hardtunes" :className="'icon-button hardtunes'">

				<Icon :icon="'hardtunes'"></Icon>

			</a>

			<!-- Hardstyle -->
			<a title="Hardstyle.com" :href="UNDEFIANT.hardstylecom" :className="'icon-button hardstyle-com'">

				<Icon :icon="'hardstyle-com'"></Icon>

			</a>

			<!-- Beatport -->
			<a title="Beatport" :href="UNDEFIANT.beatport" :className="'icon-button beatport'">

				<Icon :icon="'beatport'"></Icon>

			</a>

			<!-- Facebook -->
			<a title="Facebook" :href="UNDEFIANT.facebook" :className="'icon-button facebook'">

				<Icon :icon="'facebook'"></Icon>

			</a>
			
		</div>
		
		<div class="albums">

			<div
				class="album"
				v-for="(release, index) in RELEASES" 
				:key="index"
				:title="release.name"
				:name="release.name"
			>

				<img :src="'src/img/covers/'+release.name.replaceAll(' ', '-')+'.jpg'" :alt="release.name">

				<div class="popup" v-if="!showLinks">

					<strong>{{ release.name }}</strong><br>

					Artist: 
					<span 
						class="artist"
						v-for="(artist, index2) in release.artists" 
						:key="index2"
						:title="artist.name"
						:name="artist.name"
					>

						{{ artist.name }}<span class="comma" v-if="index2 < release.artists.length - 1">, </span>

						<span class="artist-popup">

							{{ artist.name }} socials<br>

							<a title="Spotify" class="icon-button spotify" v-if="artist.spotify" :href="artist.spotify"><Icon :icon="'spotify'"></Icon></a>
							<a title="Apple Music" class="icon-button apple-music" v-if="artist.appleMusic" :href="artist.appleMusic"><Icon :icon="'apple-music'"></Icon></a>
							<a title="Instagram" class="icon-button instagram" v-if="artist.instagram" :href="artist.instagram"><Icon :icon="'instagram'"></Icon></a>
							<a title="YouTube" class="icon-button youtube" v-if="artist.youtube" :href="artist.youtube"><Icon :icon="'youtube'"></Icon></a>
							<a title="SoundCloud" class="icon-button soundcloud" v-if="artist.soundCloud" :href="artist.soundCloud"><Icon :icon="'soundcloud'"></Icon></a>

						</span>

					</span>

					<br>

					Label: {{ release.recordLabel }}<br>
					Released: {{ release.releaseDate.toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: 'numeric' }) }}<br>

					<a title="Spotify" class="icon-button spotify" v-if="release.spotify" :href="release.spotify"><Icon :icon="'spotify'"></Icon></a>
					<a title="Apple Music" class="icon-button apple-music" v-if="release.appleMusic" :href="release.appleMusic"><Icon :icon="'apple-music'"></Icon></a>
					<a title="iTunes" class="icon-button itunes" v-if="release.itunes" :href="release.itunes"><Icon :icon="'itunes'"></Icon></a>
					<a title="YouTube" class="icon-button youtube" v-if="release.youtube" :href="release.youtube"><Icon :icon="'youtube'"></Icon></a>
					<a title="YouTube Music" class="icon-button youtube-music" v-if="release.youtubeMusic" :href="release.youtubeMusic"><Icon :icon="'youtube-music'"></Icon></a>
					<a title="SoundCloud" class="icon-button soundcloud" v-if="release.soundCloud" :href="release.soundCloud"><Icon :icon="'soundcloud'"></Icon></a>
					<a title="Amazon Music" class="icon-button amazon-music" v-if="release.amazonMusic" :href="release.amazonMusic"><Icon :icon="'amazon-music'"></Icon></a>
					<a title="Deezer" class="icon-button deezer" v-if="release.deezer" :href="release.deezer"><Icon :icon="'deezer'"></Icon></a>
					<a title="Hardtunes" class="icon-button hardtunes" v-if="release.hardtunes" :href="release.hardtunes"><Icon :icon="'hardtunes'"></Icon></a>
					<a title="Hardstyle.com" class="icon-button hardstyle-com" v-if="release.hardstylecom" :href="release.hardstylecom"><Icon :icon="'hardstyle-com'"></Icon></a>
					<a title="Beatport" class="icon-button beatport" v-if="release.beatport" :href="release.beatport"><Icon :icon="'beatport'"></Icon></a> 

				</div>
				<div class="popup" v-else>
					<a :href="'/src/releases/'+release.wavLink">Download</a>					
				</div>

			</div>

		</div>

	</div>

</template>
	
<script lang="ts">
	
	import { Options, Vue } from 'vue-class-component';
	import { RELEASES, UNDEFIANT } from '@/data';
	import Icon from './Icon/Icon.vue';
	
	@Options({
		props: {
			/*
			[Optional]
			Show release links
			*/
			showLinks: {
				type: Boolean,
				default: false
			},
		},
		components: {
			Icon
		}
	})
	export default class Home extends Vue
	{
		public RELEASES = RELEASES;
		public UNDEFIANT = UNDEFIANT;
	}
	
</script>
	
<style lang="scss" scoped>
	
	@import url('/public/src/css/home.scss');
	
</style>